// extracted by mini-css-extract-plugin
module.exports = {"formList":"formList___3eQ2Y"};